import {
  Button,
  paletteHelper,
  spacingHelper,
  typographyHelper,
  mediaHelper,
} from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { applyFeatureButtonStyle } from '../../../../../app-kit/helpers/featureButtonStyle';

export const homePageSearchButtonLabelClassName = 'home-page-search-button-label';
export const multiIntentSearchModalButtonIconClassName = 'multi-intent-search-modal-button-icon';

export const MultiIntentSearchModalButton = styled(Button)`
  width: 100%;
  justify-content: space-between;
  padding: ${spacingHelper('extraSmall extraSmall extraSmall large')};
  background: ${paletteHelper('backgroundPrimaryBase')};

  &:focus-within {
    color: ${paletteHelper('textSecondary')};
    background: ${paletteHelper('backgroundPrimaryBase')};
  }

  &:hover {
    background: ${paletteHelper('backgroundPrimaryBase')};
  }

  ${applyFeatureButtonStyle(multiIntentSearchModalButtonIconClassName)}

  .${homePageSearchButtonLabelClassName} {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
    ${typographyHelper('title03Light')}
    font-size: 1.25rem;

    ${mediaHelper('mobile')} {
      font-size: 1rem;
      font-weight: 400;
    }
  }

  &:hover .${homePageSearchButtonLabelClassName} {
    white-space: unset;
  }

  ${mediaHelper('tabletMax')} {
    padding-right: calc(${spacingHelper('small')} / 2);
  }
`;
